import { FC } from "react";

interface InputContainerProps {
  id: string;
  title?: string;
  className?: string;
  children: React.ReactNode;
}
export const InputContainer: FC<any> = ({ title, children, className = "py-2"}:InputContainerProps) => {

  return (
    <div className={className}>
      {title && <h4 className="text-capitalize">{title}</h4>}

    <div className={"container ebd-container-bg mb-4 pt-2 pb-3"}>{children}</div>
    </div>
  );
};
